import styled from "styled-components"

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  color: #333;
`

export const Loading = styled.div`
  position: absolute;
  z-index: -1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: #f6f6f6;

  h3 {
    margin-top: 12px;
  }
`
